import React from 'react';
import classNames from 'classnames';
import { APP_BG } from '@/constant/theme/colors.constant';

interface FullPageCardProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  pageClassName?: string;
  className?: string;
  contentClassName?: string;
  footerClassName?: string;
  testId?: string;
}

const FullPageCard = ({
  children,
  header,
  footer,
  pageClassName,
  className,
  contentClassName,
  footerClassName,
  testId,
}: FullPageCardProps) => (
  <section
    data-testid={testId ?? ''}
    className={classNames(
      'flex h-full min-h-0 w-full flex-col overflow-hidden',
      pageClassName,
    )}
  >
    {header}

    <div
      className={classNames(
        `flex flex-1 min-h-0 flex-col overflow-hidden ${APP_BG.canvas}`,
        className,
      )}
    >
      <div
        className={classNames(
          'flex-1 min-h-0 flex flex-col',
          contentClassName,
        )}
      >
        {children}
      </div>

      {footer ? (
        <div
          className={classNames(
            `border-t border-gray-100 px-4 py-2 dark:border-white/10 ${APP_BG.elevated}`,
            footerClassName,
          )}
        >
          {footer}
        </div>
      ) : null}
    </div>
  </section>
);

export default FullPageCard;
